// import * as React from "react";
import React, { FC, useRef } from "react";
import { Select } from "antd";

import {
  SpreadsheetComponent,
  getRangeAddress,
  SheetsDirective,
  SheetDirective,
  RangesDirective,
  RowsDirective,
  RowDirective,
  CellDirective,
  CellsDirective,
  getCellAddress,
} from "@syncfusion/ej2-react-spreadsheet";
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import {
  RadioButtonComponent,
  ButtonComponent,
} from "@syncfusion/ej2-react-buttons";
import {
  DropDownListComponent,
  MultiSelectComponent,
} from "@syncfusion/ej2-react-dropdowns";
import { SelectionSettingsModel } from "@syncfusion/ej2-react-spreadsheet";
import { select } from "@syncfusion/ej2-base";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import _, { stubObject, values } from "lodash";
import { registerLicense } from "@syncfusion/ej2-base";

import FixedAssetInput from "../../../../common/FixedAssetInput";
import TaskInput from "../../../../common/TaskSelectInput";
import ResponderInput from "../../../../common/ResponderInput";
import DateInput from "../../../../common/DateInput";
import TimeInput from "../../../../common/TimeInput";
import LocationInput from "../../../../common/LocationInput";

registerLicense(process.env.REACT_APP_SYNCFUSION_KEY);

const { Option } = Select;
let timeout;

const SpreadSheet: FC<{
  onClose?: () => void;
  adminRoles?: any;
  onSubmitHandler?: any;
}> = ({ onClose, adminRoles, onSubmitHandler }) => {
  const spreadsheet: any = useRef();
  const insertAdded: any = useRef<boolean>(false);
  const { search } = useLocation();
  const history = useHistory();
  const projects = useSelector(
    (state: RootState) => state.auth.projects,
    (a, b) => {
      return JSON.stringify(a) === JSON.stringify(b);
    }
  );
  let selectedValues: any = useRef({});

  const projectSelect = (args) => {
    return (
      <Select
        showSearch
        className="w-full"
        placeholder={"Select project"}
        value={selectedValues.current[args?.rowIndex]?.project}
        onChange={(value) => {
          if (!selectedValues.current[args?.rowIndex]) {
            selectedValues.current[args?.rowIndex] = {};
          }
          selectedValues.current[args?.rowIndex].project = value;
          args?.spreadsheet.current.updateCell({ value }, args?.address);
        }}
        filterOption={(input, option) =>
          (option!.children as unknown as string)
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      >
        {projects?.projects?.map((project, index) => (
          <Option value={project.id}>{project.name}</Option>
        ))}
      </Select>
    );
  };

  const scheduleSelect = (args) => {
    const options = [
      { id: "immediate", name: "Immediate" },
      { id: "schedule", name: "Schedule" },
      { id: "deadline", name: "Deadline" },
    ];
    return (
      <Select
        showSearch
        className="w-full"
        placeholder={"Select dispatch type"}
        value={selectedValues.current[args?.rowIndex]?.dispatchType}
        onChange={(value) => {
          if (!selectedValues.current[args?.rowIndex]) {
            selectedValues.current[args?.rowIndex] = {};
          }
          selectedValues.current[args?.rowIndex].dispatchType = value;
          args?.spreadsheet.current.updateCell({ value }, args?.address);
        }}
        filterOption={(input, option) =>
          (option!.children as unknown as string)
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      >
        {options?.map((option, index) => (
          <Option value={option.id}>{option.name}</Option>
        ))}
      </Select>
    );
  };

  const taskSelect = (args) => {
    return (
      <TaskInput
        placeholder={"Select task"}
        rowIndex={args?.rowIndex}
        allProjects={selectedValues}
        value={selectedValues.current[args?.rowIndex]?.task}
        onChange={(value: any) => {
          if (!selectedValues.current[args?.rowIndex]) {
            selectedValues.current[args?.rowIndex] = {};
          }
          selectedValues.current[args?.rowIndex].task = value;
          args?.spreadsheet.current.updateCell(
            { value: value?.task?.id?.toString() },
            args?.address
          );
        }}
      />
    );
  };

  const dateSelect = (args) => {
    return (
      <div className="datetime-item">
        <DateInput
          placeholder={"Select date"}
          value={selectedValues.current[args?.rowIndex]?.date}
          onChange={(value: any) => {
            if (!selectedValues.current[args?.rowIndex]) {
              selectedValues.current[args?.rowIndex] = {};
            }
            selectedValues.current[args?.rowIndex].date = value;
            args?.spreadsheet.current.updateCell(
              { value: value },
              args?.address
            );
          }}
        />
      </div>
    );
  };

  const timeSelect = (args) => {
    return (
      <TimeInput
        name={"Select time"}
        value={selectedValues.current[args?.rowIndex]?.time}
        onChange={(value: any) => {
          if (!selectedValues.current[args?.rowIndex]) {
            selectedValues.current[args?.rowIndex] = {};
          }
          selectedValues.current[args?.rowIndex].time = value;
          args?.spreadsheet.current.updateCell({ value: value }, args?.address);
        }}
      />
    );
  };

  const locationSelect = (args) => {
    return (
      <LocationInput
        placeholder={"Select location"}
        value={selectedValues.current[args?.rowIndex]?.incidentLocation}
        onChange={(value: any) => {
          if (!selectedValues.current[args?.rowIndex]) {
            selectedValues.current[args?.rowIndex] = {};
          }
          selectedValues.current[args?.rowIndex].incidentLocation = value;
        }}
      />
    );
  };

  const responderSelect = (args) => {
    return (
      <ResponderInput
        placeholder={"Select responder"}
        adminRoles={adminRoles}
        value={selectedValues.current[args?.rowIndex]?.responder}
        onChange={(value: any) => {
          if (!selectedValues.current[args?.rowIndex]) {
            selectedValues.current[args?.rowIndex] = {};
          }
          selectedValues.current[args?.rowIndex].responder = value;
          args?.spreadsheet.current.updateCell(
            { value: value?.responders?.[0]?.id?.toString() },
            args?.address
          );
        }}
      />
    );
  };

  const poiSelect = (args) => {
    return (
      <FixedAssetInput
        placeholder={"Select location"}
        value={selectedValues.current[args?.rowIndex]?.location}
        onChange={(value: any) => {
          if (!selectedValues.current[args?.rowIndex]) {
            selectedValues.current[args?.rowIndex] = {};
          }
          selectedValues.current[args?.rowIndex].location = value;
          args?.spreadsheet.current.updateCell(
            { value: value?.asset?.name },
            args?.address
          );
          args?.spreadsheet.current.updateCell(
            { value: value?.asset?.location?.coordinates?.[1] },
            getCellAddress(args?.rowIndex, 1)
          );
          args?.spreadsheet.current.updateCell(
            { value: value?.asset?.location?.coordinates?.[0] },
            getCellAddress(args?.rowIndex, 2)
          );
        }}
      />
    );
  };

  const onCreated = () => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      spreadsheet.current.addFileMenuItems(
        [{ text: "Submit", iconCss: "e-icons e-save-2" }],
        "Open"
      );
    }, 1000);
  };

  const fileMenuItemSelect = (args) => {
    // Custom file menu items select handler
    switch (args.item.text) {
      case "Insert row":
        let sections = getSections();
        let sheets = spreadsheet.current.sheets;
        let rowIndex = sheets[0].usedRange.rowIndex;
        spreadsheet.current.insertRow(rowIndex);
        sections.map((section, idy) => {
          if (section?.type === "project") {
            spreadsheet.current.updateRange({
              template: () => {
                return projectSelect({
                  address: getCellAddress(rowIndex, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: rowIndex,
                });
              },
              address: getCellAddress(rowIndex, idy),
            });
          } else if (section?.type === "dispatchType") {
            spreadsheet.current.updateRange({
              template: () => {
                return scheduleSelect({
                  address: getCellAddress(rowIndex, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: rowIndex,
                });
              },
              address: getCellAddress(rowIndex, idy),
            });
          } else if (section?.type === "responder") {
            spreadsheet.current.updateRange({
              template: () => {
                return responderSelect({
                  address: getCellAddress(rowIndex, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: rowIndex,
                });
              },
              address: getCellAddress(rowIndex, idy),
            });
          } else if (section?.type === "fixed-asset") {
            spreadsheet.current.updateRange({
              template: () => {
                return poiSelect({
                  address: getCellAddress(rowIndex, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: rowIndex,
                });
              },
              address: getCellAddress(rowIndex, idy),
            });
          } else if (section?.type === "task-picker") {
            spreadsheet.current.updateRange({
              template: () => {
                return taskSelect({
                  address: getCellAddress(rowIndex, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: rowIndex,
                });
              },
              address: getCellAddress(rowIndex, idy),
            });
          } else if (
            section?.type === "date" ||
            section?.type === "dispatchDate"
          ) {
            spreadsheet.current.updateRange({
              template: () => {
                return dateSelect({
                  address: getCellAddress(rowIndex, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: rowIndex,
                });
              },
              address: getCellAddress(rowIndex, idy),
            });
          } else if (
            section?.type === "time" ||
            section?.type === "dispatchTime"
          ) {
            spreadsheet.current.updateRange({
              template: () => {
                return timeSelect({
                  address: getCellAddress(rowIndex, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: rowIndex,
                });
              },
              address: getCellAddress(rowIndex, idy),
            });
          } else if (section?.type === "incident-location") {
            spreadsheet.current.updateRange({
              template: () => {
                return locationSelect({
                  address: getCellAddress(rowIndex, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: rowIndex,
                });
              },
              address: getCellAddress(rowIndex, idy),
            });
          }
        });
        setTimeout(() => {
          spreadsheet.current.setRowsHeight(53);
          spreadsheet.current.setColumnsWidth(150);
        }, 100);

        break;
      case "Submit":
        spreadsheet.current.saveAsJson().then((response) => {
          const json = [];
          console.log("save", response, selectedValues);
          const rows = response?.jsonObject?.Workbook?.sheets?.[0]?.rows ?? [];
          const sections = getSections();
          Object.keys(selectedValues.current).map((rowIndex) => {
            const cols = rows?.[rowIndex]?.cells;
            const obj: any = {};
            sections.map((section, idx) => {
              obj[section.label] = cols?.[idx]?.value;
              if (section.type === "project") {
                obj[section.label] =
                  selectedValues.current?.[rowIndex]?.project;
              } else if (section.type === "fixed-asset") {
                obj[section.label] =
                  selectedValues.current?.[rowIndex]?.location;
              } else if (section.type === "responder") {
                obj[section.label] =
                  selectedValues.current?.[rowIndex]?.responder;
              } else if (section.type === "task-picker") {
                obj[section.label] = selectedValues.current?.[rowIndex]?.task;
              } else if (section.type === "date") {
                obj[section.label] = selectedValues.current?.[rowIndex]?.date;
              } else if (section.type === "time") {
                obj[section.label] = selectedValues.current?.[rowIndex]?.time;
              } else if (section.type === "incident-location") {
                obj[section.label] =
                  selectedValues.current?.[rowIndex]?.incidentLocation;
              } else if (section.type === "dispatchType") {
                obj["dispatch"] = {
                  value: selectedValues.current?.[rowIndex]?.dispatchType,
                  type: "dispatchType",
                  date: selectedValues.current?.[rowIndex]?.date,
                  time: selectedValues.current?.[rowIndex]?.time,
                };
              }
            });
            delete obj.dispatchDate;
            delete obj.dispatchTime;
            delete obj.dispatchType;
            json.push(obj);
          });
          json.map((obj) => {
            const response = onSubmitHandler(obj);
            console.log("submit", response);
            return response;
          });
        });
        break;
    }
  };

  const getSections = () => {
    const query = new URLSearchParams(search);
    const projectId = query.get("projectId");

    let sections =
      projectId && projectId !== ""
        ? projects?.sections?.[1]?.[0]?.[projectId] || []
        : projects?.sections?.[0]?.[0];

    const headers: any[] = [
      { label: "title" },
      { label: "location-lat" },
      { label: "location-long" },
    ];
    sections.forEach((section: any) => {
      section.Rows.forEach((row: any) => {
        row.Cols.forEach((col: any) => {
          headers.push({ label: col.name, type: col.type });
        });
      });
    });
    headers.push({ label: "dispatchType", type: "dispatchType" });
    headers.push({ label: "dispatchDate", type: "dispatchDate" });
    headers.push({ label: "dispatchTime", type: "dispatchTime" });
    return headers;
  };

  const openComplete = () => {
    let sheets = spreadsheet.current.sheets;
    for (let index = 0; index < sheets.length; index++) {
      let name = spreadsheet.current.sheets[index].name;
      let address = getRangeAddress([
        0,
        0,
        sheets[index].usedRange.rowIndex,
        sheets[index].usedRange.colIndex,
      ]);

      let sections = getSections();
      let rowsRange = [...Array(sheets[index].usedRange.rowIndex - 1).keys()];

      sections.map((section, idy) => {
        if (section?.type === "project") {
          rowsRange.map((idx) => {
            spreadsheet.current.updateRange({
              template: () => {
                return projectSelect({
                  address: getCellAddress(idx + 1, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: idx + 1,
                });
              },
              address: getCellAddress(idx + 1, idy),
            });
          });
        } else if (section?.type === "dispatchType") {
          rowsRange.map((idx) => {
            spreadsheet.current.updateRange({
              template: () => {
                return scheduleSelect({
                  address: getCellAddress(idx + 1, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: idx + 1,
                });
              },
              address: getCellAddress(idx + 1, idy),
            });
          });
        } else if (section?.type === "responder") {
          rowsRange.map((idx) => {
            spreadsheet.current.updateRange({
              template: () => {
                return responderSelect({
                  address: getCellAddress(idx + 1, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: idx + 1,
                });
              },
              address: getCellAddress(idx + 1, idy),
            });
          });
        } else if (section?.type === "fixed-asset") {
          rowsRange.map((idx) => {
            spreadsheet.current.updateRange({
              template: () => {
                return poiSelect({
                  address: getCellAddress(idx + 1, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: idx + 1,
                });
              },
              address: getCellAddress(idx + 1, idy),
            });
          });
        } else if (section?.type === "task-picker") {
          rowsRange.map((idx) => {
            spreadsheet.current.updateRange({
              template: () => {
                return taskSelect({
                  address: getCellAddress(idx + 1, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: idx + 1,
                });
              },
              address: getCellAddress(idx + 1, idy),
            });
          });
        } else if (
          section?.type === "date" ||
          section?.type === "dispatchDate"
        ) {
          rowsRange.map((idx) => {
            spreadsheet.current.updateRange({
              template: () => {
                return dateSelect({
                  address: getCellAddress(idx + 1, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: idx + 1,
                });
              },
              address: getCellAddress(idx + 1, idy),
            });
          });
        } else if (
          section?.type === "time" ||
          section?.type === "dispatchTime"
        ) {
          rowsRange.map((idx) => {
            spreadsheet.current.updateRange({
              template: () => {
                return timeSelect({
                  address: getCellAddress(idx + 1, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: idx + 1,
                });
              },
              address: getCellAddress(idx + 1, idy),
            });
          });
        } else if (section?.type === "incident-location") {
          rowsRange.map((idx) => {
            spreadsheet.current.updateRange({
              template: () => {
                return locationSelect({
                  address: getCellAddress(idx + 1, idy),
                  spreadsheet: spreadsheet,
                  rowIndex: idx + 1,
                });
              },
              address: getCellAddress(idx + 1, idy),
            });
          });
        }
      });

      setTimeout(() => {
        spreadsheet.current.setRowsHeight(50);
        spreadsheet.current.setColumnsWidth(150);
        if (!insertAdded.current) {
          spreadsheet.current.addFileMenuItems(
            [{ text: "Insert row", iconCss: "e-icons e-plus" }],
            "Open"
          );
          insertAdded.current = true;
        }
      }, 100);
    }
  };

  return (
    <div className="control-pane">
      <div className="control-section spreadsheet-control">
        <SpreadsheetComponent
          allowDelete={false}
          allowOpen={true}
          openUrl="https://ej2services.syncfusion.com/production/web-services/api/spreadsheet/open"
          openComplete={openComplete}
          allowSave={true}
          saveUrl="https://ej2services.syncfusion.com/production/web-services/api/spreadsheet/save"
          ref={(ssObj) => {
            spreadsheet.current = ssObj;
          }}
          created={onCreated}
          fileMenuItemSelect={fileMenuItemSelect}
        >
          <SheetsDirective>
            <SheetDirective
              name="Event form"
              rowCount={40}
              colCount={30}
              showGridLines={true}
            ></SheetDirective>
          </SheetsDirective>
        </SpreadsheetComponent>
      </div>
    </div>
  );
};

export default SpreadSheet;
